import React from 'react';
import {
    Link
} from "react-router-dom";

const deals = (props) => {
    return (
        props.deals.map( deal => (
            <div className={deal.is_bumped ? "item green-border" : "item"} key={deal._id}>
                <Link to={process.env.PUBLIC_URL+"/allday/deal/"+deal._id}>
                    <div className={deal.is_bumped ? "category-box-outer deals-highlight" : "category-box-outer"}>
                        <div className="offers-tag-outer">
                            <ul className="list-unstyled mb-0 ">
                                {deal.badges.map(badge => (
                                    <li key={badge._id}><img src={badge.image_full} alt="specialdeals"/></li>
                                ))}
                            </ul>
                        </div>
                        <div className="category-box-header">
                            <img src={deal.image} alt={deal.name}/>
                            {deal.is_bumped && <div className="featured-deal">Featured</div>}
                        </div>
                        <div className="category-box-body">
                            <p className="category-box-body-title d-inline-block">{deal.name}</p>
                            {deal.rating > 0 &&
                            <div className="dealbox-rating-count custom-rating">
                                <img src={`${process.env.PUBLIC_URL}/image/star.png`} alt="star-rate"/><span className="star-text">{deal.rating}</span>
                            </div>
                            }
                            <div className="deal_rating_sec">
                                <div className="deal_title_first">
                                    <p className="category-box-body-subtitle custom-height">{deal.subtitle}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        ))
    );
}

export default deals;